import React from 'react';
import { BasicFetch } from '../utils/BasicFetch.ts';
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, info) {

    BasicFetch({
      url: `${(window as any).serverLocation}/log_error`,
      method: 'POST',
      contentType: 'application/json',
      data: {
        error_message: error.toString(),
        error_stack: info.componentStack.toString(),
        version_number: (window as any).versionNumber,
        current_component: (window as any).currentComponent,
      },
      onSuccess: (data) => {
      }
    })
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return this.props.fallback;
    }

    return this.props.children;
  }
}